module.exports = __webpack_public_path__ + "media/images/vouchers/spa_balneo_duo-d010ebcd7db429a7cb0574f9816a4062.png";